import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import styled from 'styled-components';
import { Box } from '../Box/Box.js';

var CardContainer = styled(Box).attrs(function (props) {
  return _objectSpread({
    borderRadius: 2,
    elevation: 0,
    elevationHover: 2
  }, props);
}).withConfig({
  displayName: "CardContainer",
  componentId: "sc-p769qm-0"
})(["&&{margin:0;max-height:inherit;", ";}"], function (props) {
  return props.selected && "\n        border-color: ".concat(props.theme.CTAColors.primary, ";\n    ");
});

export { CardContainer };
